// import store from '@/state/store'
import { useAuthStore } from "@/state/pinia";
import { canPermissions } from "@/helpers/middleware_func";

export default (to, from, next, permissions) => {
    const authStore = useAuthStore();

    if (!authStore.loggedIn) {
        next({ name: 'login' });
        return;
    }

    const hasRequiredPermissions = canPermissions(permissions);
    
    if (!hasRequiredPermissions) {
        next({ name: 'Error-404' });
        return;
    }
}

